module.exports = __webpack_public_path__ + "img/03.0bc30e67.jpg";